import { frontendURL } from '../../../helper/URLHelper';

const ClaudiaLayout = () => import('../claudia/components/ClaudiaLayout.vue');
const TagsView = () => import('./pages/TagsView.vue');

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/tags'),
      name: 'tags_app',
      component: ClaudiaLayout,
      meta: {
        permissions: ['administrator', 'agent', 'custom_role'],
      },
      children: [
        {
          path: '',
          redirect: 'view',
        },
        {
          path: 'view/:tagsId?',
          name: 'tags_view',
          component: TagsView,
          meta: {
            permissions: ['administrator', 'agent', 'custom_role'],
          },
        },
      ],
    },
  ],
};
